import { CUSTOM_VIEW_GROUPS } from 'src/graphql/entities/custom-view/constants';
import {
  CustomViewAttribute,
  UIType,
} from 'src/graphql/entities/custom-view/custom-view.types';
import { ClientAttribute, ClientAttributeAccessors, ClientAttributeType } from './constants';

export const clientAttributeConfigList: CustomViewAttribute<ClientAttributeType>[] = [
  {
    attribute: ClientAttribute.partnerName,
    attributeLabel: 'Partner Name',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Partner,
    default: true,
  },
  {
    attribute: ClientAttribute.timeZone,
    attributeLabel: 'Timezone',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Partner,
  },
  {
    attribute: ClientAttribute.name,
    attributeLabel: 'Name',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Client,
    default: true,
  },
  {
    attribute: ClientAttribute.firstName,
    attributeLabel: 'First Name',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Client,
    default: false,
  },
  {
    attribute: ClientAttribute.lastName,
    attributeLabel: 'Last Name',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Client,
    default: false,
  },
  {
    attribute: ClientAttribute.phone,
    attributeLabel: 'Phone',
    uiType: UIType.Number,
    group: CUSTOM_VIEW_GROUPS.Client,
    default: true,
  },
  {
    attribute: ClientAttribute.email,
    attributeLabel: 'Email',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Client,
    default: true,
  },
  {
    attribute: ClientAttribute.marketingOptOut,
    attributeLabel: 'Marketing Opt Out',
    uiType: UIType.Boolean,
    group: CUSTOM_VIEW_GROUPS.Client,
    default: false,
  },
  {
    attribute: ClientAttribute.id,
    attributeLabel: 'Client ID',
    uiType: UIType.Text,
    group: CUSTOM_VIEW_GROUPS.Client,
    default: true,
  },
  {
    attribute: ClientAttribute.createdAt,
    attributeLabel: 'Created At',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Client,
    default: true,
  },
  {
    attribute: ClientAttribute.updatedAt,
    attributeLabel: 'Updated At',
    uiType: UIType.Date,
    group: CUSTOM_VIEW_GROUPS.Client,
    default: true,
  },
].map((i) => ({
  ...i,
  accessor: ClientAttributeAccessors[i.attribute].display,
  sortingKey: ClientAttributeAccessors[i.attribute].sort,
  sortingAggFunction: ClientAttributeAccessors[i.attribute].aggFunction,
}));

export const clientAttributeConfigMap = new Map(
  clientAttributeConfigList.map((i) => [i.attribute, i]),
);
